import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import AccumulatedTable from "../../components/tables/AccumulatedTbl";
import { fetchProductionAccumulated } from "../../action/ProductionAction";

const Production = () => {
  const dispatch = useDispatch();

  const { productionData, productionLoading, productionError } = useSelector(
    (state) => state.productionAccumulate || {}
  );

  useEffect(() => {
    dispatch(fetchProductionAccumulated());
  }, [dispatch]);

  return (
    <Box>
      {productionLoading && (
        <Box
          sx={{
            textAlign: "center",
            py: 6,
            color: "#64748b",
            fontFamily: "'Poppins', sans-serif",
            fontSize: 14,
          }}
        >
          Loading…
        </Box>
      )}

      {productionError && (
        <Box
          sx={{
            color: "#dc2626",
            p: 2,
            fontFamily: "'Poppins', sans-serif",
            background: "rgba(220,38,38,0.06)",
            borderRadius: "10px",
            border: "1px solid rgba(220,38,38,0.2)",
            mb: 2,
          }}
        >
          {productionError}
        </Box>
      )}

      {/* Always render the table so IWO group selector works */}
      <AccumulatedTable rows={Array.isArray(productionData) ? productionData : []} />
    </Box>
  );
};

export default Production;